import { UsersDto } from '../../../models/dtos/users.dto';
import axios from '../../axios';

export default async function getUsersRepository(): Promise<UsersDto> {
  const response = await axios.get<UsersDto>(`${process.env.REACT_APP_BASE_URL}/user`);
  return response.data;
}
